import React from 'react';
import PropTypes from 'prop-types';

import I18n from '@module/i18n';

import FormNotification from '@component/form/element/formnotification';
import TextField from '@component/form/element/textfield';

import { formHelpers } from '../index';

const makeVAT = (currentValue = '', country = {}) => {
  // No country (Return the current value)
  if (!country) {
    return currentValue;
  }

  // Country has no prefix (Return the current value)
  if (!country.vatPrefix) {
    return currentValue;
  }

  const prefix = country.vatPrefix;

  // Is the value same as the country prefix (Return current value)
  if (currentValue === prefix) {
    return currentValue;
  }

  if (currentValue.length <= 2) {
    return prefix;
  }

  // Prepend prefix in the current value, if missing
  if (currentValue.substr(0, 2) !== country.vatPrefix) {
    return prefix + currentValue;
  }

  return currentValue;
};

const VatField = ({
  value,
  errorMessage,
  updateValue,
  resetError,
  formName,
  countryCode = '',
}) => {
  const country = formHelpers.getCountryByCode(countryCode);
  const fieldValue = makeVAT(value, country);
  const onChange = (e) => {
    resetError(formName, 'vat_number');
    updateValue('vat_number', makeVAT(e.target.value, country), true);
  };

  return (
    <div>
      <TextField
        label={
          I18n.t('form.account.label.vat_number') +
          ' ' +
          I18n.t('form.account.label.not_required')
        }
        value={fieldValue}
        name="vat_number"
        onChange={onChange}
        valid={0}
        description={I18n.t('form.account.description.vat_number')}
        hidden={country && !country.vatPrefix}
      />
      <FormNotification message={errorMessage} type="error" />
    </div>
  );
};

VatField.propTypes = {
  value: PropTypes.string,
  errorMessage: PropTypes.string,
  updateValue: PropTypes.func.isRequired,
  resetError: PropTypes.func.isRequired,
  formName: PropTypes.string.isRequired,
  countryCode: PropTypes.string,
};

VatField.defaultProps = {
  value: '',
};

export default VatField;
